import React, { useState, useEffect, useCallback } from 'react';
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getCompany } from "../../../shared/api/action/CompaniesActions";
import { useAuth } from "../../providers/AuthContext";

const PatternsPartnerRedirectContainer = (props) => {
	const params = useParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const { login } = useAuth();
	const { t } = useTranslation('translation', { keyPrefix: 'patternsPage' });
	const [error, setError] = useState('');

	const updatePartnerPortalRedirect = useCallback((payload) => {
		dispatch({ type: 'SET_PARTNER_PORTAL_REDIRECT', payload });
	}, [dispatch]);

	useEffect(() => {
		const hash = location.hash.replace("#", "");
		const hashParams = new URLSearchParams(hash);
		// ToDo: Cognito - disable
		const s_t = hashParams.get("s_t");
		// const a_t = hashParams.get("a_t");
		// const r_t = hashParams.get("r_t");

		// if (!a_t || !r_t) {
		if (!s_t) {
			navigate("/login", { replace: true });
			return;
		}

		const run = async () => {
			try {
				await login({
					session_token: s_t,
				});
				// await login({
				// 	auth_token: a_t,
				// 	auth_refresh_token: r_t,
				// });

				if (['vehiclescompany', 'company'].includes(params.page_type)) {
					updatePartnerPortalRedirect({
						type: params.page_type,
						id: params.company_id,
						company_id: params.company_id,
						portal_url: document.referrer,
					})
					navigate('/', {
						state: undefined,
						replace: true,
					});
				} else if (params.page_type === 'vehicle') {
					updatePartnerPortalRedirect({
						type: params.page_type,
						id: params.id,
						company_id: params.company_id,
						portal_url: document.referrer,
					})
					navigate('/managevehicles/edit', {
						state: {
							id: params.id,
						},
						replace: true,
					});
				} else if (params.page_type === 'profile') {
					getCompany({ company_id: params.company_id })
						.then((res) => {
							const { company } = res.data.response
							updatePartnerPortalRedirect({
								type: params.page_type,
								id: params.id,
								company_id: params.company_id,
								portal_url: document.referrer,
							})
							navigate('/managevehicles', {
								state: {
									tabKey: 2,
									profile_name: params.id,
									device_id: 'all',
									company,
								},
								replace: true,
							});
						})
						.catch((err) => {
							setError(true)
							console.log('!getCompanyById for profile error: ', err.response, err)
						})
				}
			} catch (err) {
				console.error("Redirect failed", err);
				navigate("/login", { replace: true });
			}
		};

		run();
	}, [location.hash]);

	return (
		<article>
			{error
				&& (
					<div>
						<h3>{t('error404')}</h3>
						<div>{error}</div>
						<div>
							{t('goBack')} <Link to="/" className="btn">{t('btnHome')}</Link>
						</div>
					</div>
				)}
		</article>
	)
}

export default PatternsPartnerRedirectContainer;
